export const GRAMS_PER_KILOGRAM = 1000
const KILOGRAM_DECIMALS = 3
const KILOGRAM_INPUT_PATTERN = new RegExp(`^\\d+([.,]\\d{1,${KILOGRAM_DECIMALS}})?$`)

export function parseKilograms (text) {
  const trimmed = String(text).trim()
  if (!KILOGRAM_INPUT_PATTERN.test(trimmed)) {
    return null
  }
  return Number(trimmed.replace(',', '.'))
}

export function kilogramsToGrams (kilograms) {
  return Math.round(kilograms * GRAMS_PER_KILOGRAM)
}

export function formatKilograms (grams) {
  return (grams / GRAMS_PER_KILOGRAM).toFixed(KILOGRAM_DECIMALS)
}
